// ----
// JS for Toolbox send email /guest access button
// ----

var SCM = SCM || {};

(function (ns, $, $document, undefined) {

    var sendEmailHtml;

    if ($('#sendEmailModal').length) {
        sendEmailHtml = $('#sendEmailModal')[0].outerHTML;
    }

    ns.htmlEscape = function (str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    };


    ns.htmlUnescape = function (value) {
        return String(value)
            .replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');
    };

    ns.readModelValues = function () {
        var modelValues = {
            ExplanatoryTextWithTitle: $('#ExplanatoryTextWithTitle').val(),
            SenderName: $('#SenderName').val(),
            SenderEmail: $('#SenderEmail').val(),
            CopySender: $('#CopySender').is(':checked'),
            RecipientEmail1: $('#RecipientEmail1').val(),
            RecipientEmail2: $('#RecipientEmail2').val(),
            RecipientEmail3: $('#RecipientEmail3').val(),
            RecipientEmail4: $('#RecipientEmail4').val(),
            RecipientEmail5: $('#RecipientEmail5').val(),
            Subject: $('#Subject').val(),
            OptionalMessage: $('#OptionalMessage').val(),
            SuccessfulSend: $('#SuccessfulSend').val(),
            SendersAccountId: $('#SendersAccountId').val(),
            ClientShortName: $('#ClientShortName').val(),
            ResourceTitle: $('#ResourceTitle').val(),
            BookId: $('#BookId').val(),
            ThankYouName: $('#ThankYouName').val(),
            ResourceId: $('#ResourceId').val(),
            ResourceType: $('#ResourceType').val(),
            FailedRecipients: $('#FailedRecipients').val(),
            LinkExpirationTime: $('#LinkExpirationTime').val(),
            HasAccess: $('#HasAccess').val()
        };
        return modelValues;
    };

    ns.sendEmailClickEvents = function () {        

        // send email link in share dropdown
        $('#revealSendEmail').click(function (e) {
            e.preventDefault();
            // check if email is already sent.. then restore sendemailmodel
            var $successfulSend = $('#SuccessfulSend');
            if ($successfulSend.length && $successfulSend.val() === 'True' && sendEmailHtml.length > 0) {
                $('#sendEmailModal').replaceWith(sendEmailHtml);
                $('#tseform').removeData('validator');
                $('#tseformS').removeData('unobtrusiveValidation');
                $.validator.unobtrusive.parse($('#tseform'));
            }

            // now open model pop-up
            var $targetModal = $('#sendEmailModal');
            if ($targetModal.length) {
                $('body').addClass('on-canvas');
                $targetModal.addClass('open');
                // fix to fit on screen
                $targetModal.css({
                    top: '12vh',
                    maxHeight: 'calc(100vh - 20%)',
                    overflowY: 'auto'
                });
            }
        });        

        // submit email button click
        $(document).on('click', '.tse-submit', function (e) {

            e.preventDefault();           
            
            var isValid = true;
            var $closestForm = $('#tseform');
            if ($closestForm.length > 0) {
                isValid = $closestForm.valid();
            }
            if (isValid) {
                $('#SenderName').val(ns.htmlEscape($('#SenderName').val()));
                $('#OptionalMessage').val(ns.htmlEscape($('#OptionalMessage').val()));

                var modelValues = ns.readModelValues();
                $('#sendEmailModal').addClass('on-canvas');
                $.post('/Toolbox/ToolboxSendEmailModal/ToolboxSendEmailModel', modelValues, function (data) { 
                    $('#sendEmailModal').replaceWith(data);
                }).always(function () {
                    $('#sendEmailModal').addClass('open');
                    $('#sendEmailModal').removeClass('on-canvas');
                });
            }
        });
    };

})(SCM.ToolboxSendEmail = SCM.ToolboxSendEmail || {}, jQuery, $(document));

jQuery(document).ready(function ($) {
    SCM.ToolboxSendEmail.sendEmailClickEvents();
});